import React from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import styles from './NotePriorities.module.css';

const NotePriorityList = ({ 
    priorities, 
    loading, 
    onEdit, 
    onDelete, 
    searchQuery,
    setSearchQuery
}) => {
    // Get priority badge color based on weight
    const getPriorityBadgeClass = (weight) => {
        if (weight >= 90) return styles.priorityCritical;
        if (weight >= 70) return styles.priorityHigh;
        if (weight >= 40) return styles.priorityMedium;
        if (weight >= 20) return styles.priorityLow;
        return styles.priorityMinimal;
    };

    if (loading) {
        return (
            <div className={styles.loading}>
                <div className={styles.spinner}></div>
                <p>Loading note priorities...</p>
            </div>
        );
    }

    // Store whether we have any filters active
    const hasFilters = searchQuery;

    if (priorities.length === 0 && !hasFilters) {
        return (
            <div className={styles.emptyState}>
                <h3>No Note Priorities Found</h3>
                <p>Create your first note priority to get started.</p>
            </div>
        );
    }

    return (
        <div className={styles.listContainer}>
            <div className={styles.tableHeader}>
                <div className={styles.tableHeaderContent}>
                    <h3>Note Priorities ({priorities.length})</h3>
                    <div className={styles.tableFilters}>
                        <div className={styles.filterGroup}>
                            <label htmlFor="searchFilter">Search:</label>
                            <input
                                id="searchFilter"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                placeholder="Search by priority name..."
                                className={styles.searchInput}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={styles.table}>
                <div className={styles.tableHead}>
                    <div className={styles.row}>
                        <div className={styles.cell}>Priority Name</div>
                        <div className={styles.cell}>Weight</div>
                        <div className={styles.cell}>Priority Level</div>
                        <div className={styles.cell}>Actions</div>
                    </div>
                </div>
                
                <div className={styles.tableBody}>
                    {priorities.length === 0 && (
                        <div className={styles.noResults}>
                            <p>No priorities match your search criteria</p>
                            {searchQuery && <p>Search: "{searchQuery}"</p>}
                        </div>
                    )}
                    {priorities.map((priority) => (
                        <div key={priority.priorityId} className={styles.priorityRow}>
                            <div className={styles.row}>
                                <div className={styles.cell}>
                                    <div className={styles.nameCell}>
                                        <span className={styles.name}>{priority.priorityName}</span>
                                        <span className={styles.id}>ID: {priority.priorityId}</span>
                                    </div>
                                </div>
                                
                                <div className={styles.cell}>
                                    <div className={styles.weightCell}>
                                        <span className={styles.weight}>{priority.priorityWeight}</span>
                                    </div>
                                </div>
                                
                                <div className={styles.cell}>
                                    <span className={`${styles.priorityBadge} ${getPriorityBadgeClass(priority.priorityWeight)}`}>
                                        {priority.priorityWeight >= 90 ? 'Critical' :
                                         priority.priorityWeight >= 70 ? 'High' :
                                         priority.priorityWeight >= 40 ? 'Medium' :
                                         priority.priorityWeight >= 20 ? 'Low' : 'Minimal'}
                                    </span>
                                </div>
                                
                                <div className={styles.cell}>
                                    <div className={styles.actions}>
                                        <button
                                            onClick={() => onEdit(priority)}
                                            className={styles.editButton}
                                            title="Edit"
                                        >
                                            <FaEdit />
                                        </button>
                                        <button
                                            onClick={() => onDelete(priority)}
                                            className={styles.deleteButton}
                                            title="Delete"
                                        >
                                            <FaTrashAlt />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default NotePriorityList;
